module.exports = __webpack_public_path__ + "static/hero-03-563cee35bf200b4f3a173f063ac37cad.jpg";